
import d3 from 'd3'
import Backbone from 'backbone'

class ShapeView extends Backbone.View {

  render() {
    let {$el, model} = this
    $el.attr(model.omit('type'))
    return this
  }
}

export default ShapeView
